import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import {Expenses} from './entity/expenses-entity';
import {ExpensesDTO} from './dto/expenses-dto';
import {ExpensesService} from './expenses.service';
import { ExpensesResponse, AllExpensesResponse } from '@gtpl/shared-models/hrms';
import { ExpensesRequest } from './dto/expenses-request';
@ApiTags('expenses')

@Controller('expenses')
export class ExpensesController {
    constructor(
        private expensesService: ExpensesService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createExpenses')
    async createExpenses(@Body() expensesCategoryDto:ExpensesDTO,isUpdate:boolean=false): Promise<ExpensesResponse> {
    try {
        return await this.expensesService.createExpenses(expensesCategoryDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(ExpensesResponse, error);
      }
    }
    @Post('/updateExpenses')
  async updateExpenses(@Body() expensesCategoryDto: ExpensesDTO,@Req() request:Request): Promise<ExpensesResponse> {
    try {
      console.log('update Expenses Category');expensesCategoryDto
      console.log(request);
      return await this.expensesService.createExpenses(expensesCategoryDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ExpensesResponse, error);
    }
  }
  @Post('/getAllExpensess')
  // @UseGuards(AuthGuard('jwt'))
  async getAllExpensess(): Promise<AllExpensesResponse> {
    try {
      return await this.expensesService.getAllExpensess();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllExpensesResponse, error);
    }
  }
  @Post('/activateOrDeactivateExpenses')
  async activateOrDeactivateExpenses(@Body() expensesCategoryReq: ExpensesRequest): Promise<ExpensesResponse> {
      try {
          return await this.expensesService.activateOrDeactivateExpenses(expensesCategoryReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(ExpensesResponse, err);
      }
  }
  @Post('/getAllActiveExpenses')
  async getAllActiveExpensess(@Req() request: Request): Promise<AllExpensesResponse> {
      try {
          return await this.expensesService.getAllActiveExpensess();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllExpensesResponse, error)
      }
  }
 
}
